module.exports = __webpack_public_path__ + "static/media/WhereInTheWorldSmall.8e1f931d.gif";